module.exports = __webpack_public_path__ + "media/images/plus-88b036eaa8f3cd1db11bf2d67a4488c5.svg";